import { useTranslate } from 'core/hooks/useTranslate';
import PropTypes from 'prop-types';
import React from 'react';
import LineWithText from 'core/modules/atoms/LineWithText';
import { AuthProviderButton, Button, Tag } from 'ui';

const WelcomeStep = ({ userContext, onLoginMicrosoft, setStep, setMode, onConsentRequest, shouldConsent, isLoading }) => {
  const { t } = useTranslate();

  return (
    <div className="welcome-step__container">
      <div className="welcome-step__welcome-text">Hola {userContext?.user?.displayName || userContext?.user?.userPrincipalName}!</div>
      <div style={{ marginTop: 16 }}>
        <div style={{ marginTop: 8 }}>
          {t('login:Your are adding Edelvives Digital Plus to')} <Tag label={`${userContext?.team?.displayName} - ${userContext?.channel?.displayName}`} />
        </div>
        <div style={{ marginTop: 48 }}>
          {!shouldConsent && (
            <>
              <AuthProviderButton
                testid="btn-sso-microsoft"
                provider="microsoft"
                text={`${t('login:Log in')} ${t('login:with')} ${t('login:Login with Microsoft')}`}
                isLoading={isLoading}
                onClick={onLoginMicrosoft}
              />
              <div style={{ marginTop: 16, marginBottom: 16 }}>
                <LineWithText text="O" />
              </div>
              <Button
                text={`${t('login:If you don’t have an account yet,')} ${t('login:register here')}`}
                variant="secondary"
                onClick={() => {
                  setStep(2);
                  setMode('register');
                }}
              />
            </>
          )}

          {shouldConsent && (
            <Button
              text={`Por favor, haga clic aquí para aceptar el uso de Edelvives digital plus antes de iniciar sesión`}
              variant="secondary"
              onClick={onConsentRequest}
            />
          )}
        </div>
      </div>
    </div>
  );
};

WelcomeStep.propTypes = {
  userContext: PropTypes.object,
  onLoginMicrosoft: PropTypes.func,
  setStep: PropTypes.func,
  setMode: PropTypes.func,
  onConsentRequest: PropTypes.func,
  shouldConsent: PropTypes.bool,
  isLoading: PropTypes.bool,
};

WelcomeStep.defaultProps = {
  userContext: {},
  onLoginMicrosoft: () => {},
  setStep: () => {},
  setMode: () => {},
  onConsentRequest: () => {},
  shouldConsent: false,
  isLoading: false,
};

export default WelcomeStep;
